import { css } from '@emotion/css';

import { m } from '../../motif/m';

export const statsContainerCss = css`
  display: flex;
  flex-direction: column;
  gap: ${m('--spacing-l')};
  justify-content: center;
  align-items: center;
`;

export const statCss = css`
  font-family: ${m('--h1-font-family')};
  font-stretch: condensed;
  color: ${m('--stats-stat-color')};
  font-weight: ${m('--stats-stat-font-weight')};
  font-size: ${m('--stats-stat-font-size')};
  line-height: ${m('--stats-stat-font-line-height')};
  margin: 0;
`;

export const supplementaryTextCss = css`
  font-family: ${m('--h1-font-family')};
  font-stretch: condensed;
  color: ${m('--stats-stat-color')};
  font-size: ${m('--stats-stat-supplementary-text-font-size')};
  font-weight: ${m('--stats-stat-supplementary-text-font-weight')};
  line-height: ${m('--stats-stat-font-line-height')};
  margin: 0;
`;
